module.exports = __webpack_public_path__ + "img/Foggy.8b1ff6a9.svg";